import $ from 'jquery';
import "regenerator-runtime/runtime";

import {onElementInserted} from "../core/onElementInserted";

import './common/clickable-plate-handler';
import './common/handle-post-links';
import './common/header/handle-urgent-links';
import './common/header/urgentNewsSpacer';
import './common/header/bannerSpacer';
import './common/add-target-to-link';
import './common/sidebar';
import './common/change-mobile-plate-background';
import './common/tabs';
import '../socketIO';

import {clickSwitchTrigger} from './common/modals/switch-screen';
import {bindEventsToModalNewPassword} from "./common/modals/new-password";
import {bindEventsToAuthModalCallingBtn} from "./common/modals/auth/auth-modal-btn";
import {bindEventsToModalSignUp} from "./common/modals/auth/sign-up";
import {bindEventsToModalSignIn} from "./common/modals/auth/sign-in";
import {bindEventsToModalForgotPassword} from "./common/modals/auth/forgot-password";
import {bindDisplayEventsToModal} from "./common/modals/auth/display-events";
import {cookieModalInfoHandlers} from "./common/modals/info/cookie-modal-info-handlers";
import {bindEventsToProfileChangePasswordModalCallingBtn} from './common/modals/profile/change-password-modal-btn';
import {bindEventsToMyTeamAuthModalCallingBtn} from "./common/modals/auth/myteam-auth-modal-btn";
import {handleAddTarget} from "./common/add-target-to-link";
import {changeBackgroundImage} from "./common/change-mobile-plate-background";
import {commentsHandlers} from "./common/comments-handlers";
import {eventsPostLink} from "./common/handle-post-links";
import {scrollHandlers} from "./common/scroll-handlers";
import {showPassword} from "./common/show-password";
import {eventsSidebar} from "./common/sidebar";
import {clickTabsItemLink} from "./common/tabs";
import {handleTwemoji} from "./common/twemoji";
import {bindClickEventsForDataLayerMetrics} from "./common/dataLayer/data-layer-metrica-handlers";
import {eventFixableDiv, fixDiv} from "./common/header/fixableDiv";
import {clickUrgentNews} from "./common/header/handle-urgent-links";
import {eventMobileHeader, eventScrollTracker} from "./common/header/mobile-header";
import {urgentNewsSpacerHeight} from "./common/header/urgentNewsSpacer";
import {bannerSpacerHeight} from "./common/header/bannerSpacer";
import {dropdownHover, hideDropdown} from "./common/menu/dropdown";
import {menuHandlers} from "./common/menu/menuHandlers";
import {notificationsPanelHeight} from "./common/notifications/notifications-panel-height";
import {eventsNotificationsBtn} from "./common/notifications/show-notifications-panel";
import {eventHideNavMobileBg} from "./common/menu/nav/nav-hide-bg";
import {eventHideNavMobileIcon} from "./common/menu/nav/nav-hide-icon";
import {navMobileHeight} from "./common/menu/nav/nav-mobile";
import {navOpener} from "./common/menu/nav/nav-opener";
import {backgroundReplacer} from "./common/background-replacer";
import {initReCaptcha} from "Core/recaptcha";
import {showMoreButton} from "./common/show-more-button";
import {showCatfish} from "./common/ad/catfish";
import {toggleDiv} from './common/toffle-div';
import {showAdPopup} from "./common/ad/popup/show-ad-popup";
import {navLineOpener} from "./common/menu/nav/nav-line-opener";
import {navLineWidth} from "./common/menu/nav/nav-list-width";
import {navSpacerHeight} from "./common/header/navSpacer";
import {generalHandlersAfterLoad} from "./common/ad/general-handlers";
import {addToBookmarks} from "./common/bookmarks";
import {userMaterialBookmakerHandlers} from "./materials/users/user-material-bookmaker-handlers";
import {adFoxHandlers} from "./common/ad/adfox/general";

$(() => {
    handleTwemoji();
    menuHandlers();
    clickTabsItemLink();
    eventsSidebar();
    clickUrgentNews();
    eventsPostLink();
    changeBackgroundImage();
    handleAddTarget();
    bindEventsToAuthModalCallingBtn();
    bindEventsToMyTeamAuthModalCallingBtn();
    bindEventsToModalNewPassword();
    showPassword();
    eventFixableDiv();
    urgentNewsSpacerHeight();
    bannerSpacerHeight();
    eventsNotificationsBtn();
    notificationsPanelHeight();
    cookieModalInfoHandlers();
    commentsHandlers();
    bindClickEventsForDataLayerMetrics();
    eventMobileHeader();
    eventScrollTracker();
    bindEventsToProfileChangePasswordModalCallingBtn();
    navOpener();
    navLineOpener();
    navMobileHeight();
    eventHideNavMobileBg();
    eventHideNavMobileIcon();
    dropdownHover();
    backgroundReplacer();
    showMoreButton();
    generalHandlersAfterLoad();
    showCatfish();
    toggleDiv();
    showAdPopup();
    navLineWidth();
    navSpacerHeight();
    addToBookmarks();
    userMaterialBookmakerHandlers();
    adFoxHandlers();

    $(window).on("resize", function () {
        changeBackgroundImage();
        urgentNewsSpacerHeight();
        bannerSpacerHeight();
        notificationsPanelHeight();
        eventMobileHeader();
        eventFixableDiv();
        navMobileHeight();
        menuHandlers();
        eventHideNavMobileBg();
        eventHideNavMobileIcon();
        navLineWidth();
        navSpacerHeight();
    });

    $(window).on("scroll", function () {
        fixDiv();
        scrollHandlers();
        eventFixableDiv();
        eventScrollTracker();
        hideDropdown();
    });

    onElementInserted('#modal-block', '#signup-social', async function () {
        initReCaptcha();

        bindEventsToModalSignIn();
        bindEventsToModalSignUp();
        clickSwitchTrigger();
        bindEventsToModalForgotPassword();
        bindDisplayEventsToModal();
    });
});
